/* src/app/sign-up/sign-up.component.scss */
h1 {
  padding: 48px 0;
}
h3 {
  margin-bottom: 0.35em;
}
.wrapper {
  width: 400px;
  margin: auto;
}
/*# sourceMappingURL=sign-up.component.css.map */
